import { render, staticRenderFns } from "./ChangePurchaseInvoiceRowPeriods.vue?vue&type=template&id=0af66c15"
import script from "./ChangePurchaseInvoiceRowPeriods.vue?vue&type=script&lang=ts"
export * from "./ChangePurchaseInvoiceRowPeriods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports